module.exports = __webpack_public_path__ + "static/logo-165429bc67514221d70c7211d41ae4ef.svg";